module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Abbreviations"
    }
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('b', [_vm._v("ABBREVIATIONS")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "75%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("BEC:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("British Electric Car Co Ltd")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("BET:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("British Electric Traction")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("BTC:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("British Transport Commission")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("EMB:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("Electro-Magnetic Brake Co")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("ER&TCW:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("Electric Railway & Tramway Carriage Works Co")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("GNP:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("Glasgow Numerical Printing Co")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("LMS:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("London, Midland & Scottish Railway")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("LNER:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("London & North Eastern Railway")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("LPTB")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("London Passenger Transport Board")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("LT:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("London Transport")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("LUT:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("London United Tramways")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("M&G:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("Mountain & Gibson Ltd")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("M&T:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("Maley & Taunton Ltd")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("MET:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("Metropolitan Electric Tramways")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("PCC:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("Presidents’ Conference Car")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("UDC:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("Urban District Council")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("UEC:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("United Electric Car Co Ltd")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("VAMBAC:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "abb-para"
  }, [_vm._v("variable automatic multi-notch braking and control")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-title"
  }, [_vm._v("KEY TO MAPS")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_c('img', {
    staticClass: "mi",
    attrs: {
      "alt": "",
      "src": "images/map_key1.jpg"
    }
  }), _vm._v("   Passenger lines")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_c('img', {
    staticClass: "mi",
    attrs: {
      "alt": "",
      "src": "images/map_key2.jpg"
    }
  }), _vm._v("   Lines closed before 1 January 1945")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_c('img', {
    staticClass: "mi",
    attrs: {
      "alt": "",
      "src": "images/map_key3.jpg"
    }
  }), _vm._v("   Non-passenger lines")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_c('img', {
    staticClass: "mi",
    attrs: {
      "alt": "",
      "src": "images/map_key4.jpg"
    }
  }), _vm._v("   Lines of neighbouring operators – open at 1 January 1945")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_c('img', {
    staticClass: "mi",
    attrs: {
      "alt": "",
      "src": "images/map_key5.jpg"
    }
  }), _vm._v("   Lines of neighbouring operators – closed at 1 January 1945")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_c('img', {
    staticClass: "mi",
    attrs: {
      "alt": "",
      "src": "images/map_key6.jpg"
    }
  }), _vm._v("   Passenger lines built opened after 1 January 1945")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_c('img', {
    staticClass: "mi",
    attrs: {
      "alt": "",
      "src": "images/map_key7.jpg"
    }
  }), _vm._v("   Lines under construction at 1 January 1945 – never completed")])])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aeb2d32e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Abbreviations.vue
// module id = 66
// module chunks = 0